import React, { Component } from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

class AboutItem extends Component {
  constructor(props) {
    super(props);
    const {
      title,
      description: { json: description },
      photo,
    } = this.props;
    this.state = {
      title,
      description,
      photo,
    };
  }

  getItem() {
    const { title, description, photo } = this.state;
    return (
      <div className="about-content">
        <div className="wow fadeInLeft card-info">
          <h2 className="title-2">{title}</h2>
          <div className="paragraph">{documentToReactComponents(description)}</div>
        </div>
        <Img className="wow fadeInRight about-media" fixed={photo.fixed} alt={title} />
      </div>
    );
  }

  getReversedItem() {
    const { title, description, photo } = this.state;
    return (
      <div className="about-content is-reversed">
        <Img className="wow fadeInLeft about-media" fixed={photo.fixed} alt={title} />
        <div className="wow fadeInRight card-info">
          <h2 className="title-2">{title}</h2>
          <div className="paragraph">{documentToReactComponents(description)}</div>
        </div>
      </div>
    );
  }

  render() {
    const { isReversed } = this.props;
    return !isReversed ? this.getItem() : this.getReversedItem();
  }
}

const About = ({ items }) => (
  <section className="section about">
    {items.map(({ node }, i) => (
      <AboutItem key={node.id} {...node} isReversed={!!(i % 2)} />
    ))}
  </section>
);

About.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

AboutItem.propTypes = {
  isReversed: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.shape().isRequired,
  photo: PropTypes.shape().isRequired,
};

export default About;
